import React from "react";
import {
  Grid,
  Paper,
  TextField,
  Typography,
  MenuItem,
} from "@mui/material";

interface SystemSettings {
  systemCode: string;
  unitIndex: string;
  cloudFrontBaseUrl: string;
  commonName: string;
  customerDealIdentifier: string;
  dailyAssetReportEmailList: string;
  IANA_timezone: string;
}

interface SystemSettingsFormProps {
  system: SystemSettings;
  handleChange: (field: keyof SystemSettings, value: any) => void;
}

const timezones = [
  { label: "Eastern", value: "America/Indiana/Indianapolis" },
  { label: "Central", value: "America/Chicago" },
  { label: "Mountain", value: "America/Denver" },
  { label: "Arizona", value: "America/Phoenix" },
  { label: "Pacific", value: "America/Los_Angeles" },
];

const SystemSettingsForm: React.FC<SystemSettingsFormProps> = ({
  system,
  handleChange,
}) => {
  return (
    <Paper sx={{ p: 3 }}>
      <Typography
        variant="h6"
        sx={{
          mb: 2,
          fontWeight: "bold",
          textTransform: "uppercase",
          letterSpacing: 0.5,
        }}
      >
        System Settings
      </Typography>

      <Grid container spacing={2}>
        {/* System Code */}
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            required
            label="System Code"
            inputProps={{ maxLength: 15 }}
            value={system.systemCode || ""}
            onChange={(e) => handleChange("systemCode", e.target.value)}
          />
        </Grid>

        {/* Common Name */}
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Common Name"
            value={system.commonName || ""}
            onChange={(e) => handleChange("commonName", e.target.value)}
          />
        </Grid>

        {/* Asset URL (autofill default) */}
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Asset URL"
            value={system.cloudFrontBaseUrl || "assets.bwiportal.com"}
            onChange={(e) => handleChange("cloudFrontBaseUrl", e.target.value)}
          />
        </Grid>

        {/* Zoho Deal Identifier */}
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            required
            type="text" // ✅ instead of "number"
            label="Zoho Deal Identifier"
            inputProps={{ maxLength: 19, inputMode: "numeric", pattern: "[0-9]*" }} // only digits allowed
            value={system.customerDealIdentifier || ""}
            onChange={(e) => handleChange("customerDealIdentifier", e.target.value)}
          />
        </Grid>

        {/* Daily Report Email */}
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Daily Report Email"
            placeholder="Optional"
            value={system.dailyAssetReportEmailList || ""}
            onChange={(e) =>
              handleChange("dailyAssetReportEmailList", e.target.value)
            }
          />
        </Grid>

        {/* Timezone Dropdown */}
        <Grid item xs={12} sm={6}>
          <TextField
            select
            fullWidth
            required
            label="System Timezone"
            value={system.IANA_timezone || ""}
            onChange={(e) => handleChange("IANA_timezone", e.target.value)}
          >
            {timezones.map((tz) => (
              <MenuItem key={tz.value} value={tz.value}>
                {tz.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default SystemSettingsForm;
